<template>
  <v-layout
    v-if="visibleTiers.length"
    row
    wrap
  >
    <v-flex
      xs12
      class="pa-0"
    >
      <v-btn
        v-if="!small"
        :disabled="!canScrollLess"
        flat
        class="my-0"
        block
        @click="showLess()"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
      <v-btn
        v-for="(tier, index) in visibleTiers"
        :key="index"
        :large="large"
        :small="small"
        :color="btnColor(tier)"
        :flat="!tier.selected"
        class="my-0"
        block
        @click="setQuantity(tier)"
      >
        <span class="d-block">{{ tier.quantity }} - {{ tier.nextQuantity || '&#8734;' }} </span>
        <v-spacer/>
        <span class="d-block">{{ tier.gross_price || tier.price | money }}</span>
      </v-btn>
      <v-btn
        v-if="!small"
        :disabled="!canScrollMore"
        flat
        class="my-0"
        block
        @click="showMore()"
      >
        <v-icon>keyboard_arrow_down</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ItemTiers',

  props: {
    value: {
      type: Number,
      required: true
    },
    tierPrices: {
      type: Array,
      required: true
    },
    customerGroups: {
      type: Array,
      required: false,
      default: () => []
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      manuallySelected: null
    }
  },

  computed: {
    visibleTiers () {
      if (this.small) {
        const tiers = this.mapNextQuantity(this.tierPrices)
        const tier = this.findMatchingTier(tiers)
        if (!tier) {
          return []
        }
        tier.selected = true

        return [tier]
      }

      let start = this.manuallySelected
      if (start === null) {
        start = this.tiers.findIndex(t => t.selected)
        start = start > 0 ? start - 1 : 0
      }

      return this.tiers.slice(start, start + 3)
    },
    tiers () {
      let tiers = Object.values(this.groupBy(this.tiersApplicableToGroup, 'quantity')).map(g => {
        if (g.length === 1) {
          return g.shift()
        }

        return g.find(t => t.customer_groups && this.qualifiesForCustomer(t))
      })

      tiers.sort((a, b) => a.quantity - b.quantity)
      tiers = this.mapNextQuantity(tiers)

      let matchingTier = this.findMatchingTier(tiers)
      if (matchingTier) {
        matchingTier.selected = true
      }

      return tiers
    },
    tiersApplicableToGroup () {
      return this.tierPrices.filter(t => {
        return this.qualifiesForCustomer(t) ||
          !this.customerGroups.length ||
          !t.customer_groups ||
          !t.customer_groups.length
      })
    },
    quantity: {
      set (value) {
        this.manuallySelected = null
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    },
    canScrollMore () {
      if (this.manuallySelected !== null || this.selected === -1) {
        return this.manuallySelected < this.tiers.length - 3
      }

      return this.selected !== -1 && this.selected < this.tiers.length - 2
    },
    canScrollLess () {
      if (this.manuallySelected !== null) {
        return this.manuallySelected > 0
      }

      return this.selected > 1
    },
    selected () {
      return this.tiers.findIndex(t => t.selected)
    }
  },

  methods: {
    setQuantity (tier) {
      if (this.small) {
        return
      }
      this.quantity = tier.quantity
    },

    btnColor (tier) {
      return tier.selected ? 'primary' : ''
    },

    groupBy (array, key) {
      return array.reduce((acc, item) => {
        acc[item[key]] = [...(acc[item[key]] || []), item]
        return acc
      }, {})
    },

    showLess () {
      if (this.manuallySelected !== null) {
        if (this.canScrollLess) {
          this.manuallySelected--
        }
        return
      }

      this.manuallySelected = this.selected > 0 ? this.selected - 2 : this.tiers.length - 1
    },

    showMore () {
      if (this.manuallySelected !== null) {
        if (this.canScrollMore) {
          this.manuallySelected++
        }
        return
      }

      this.manuallySelected = this.selected > 0 ? this.selected + 1 : 1
    },

    mapNextQuantity (tiers) {
      return tiers.map((t, i) => {
        t.selected = false
        const nextTier = tiers[i + 1] || null
        t.nextQuantity = nextTier ? nextTier.quantity - 1 : null
        return t
      })
    },

    findMatchingTier (tiers) {
      return tiers.slice().sort((a, b) => b.quantity - a.quantity).find(t => this.quantity >= t.quantity)
    },

    qualifiesForCustomer (tier) {
      return this.customerGroups.map(g => g.code).some((e) => tier.customer_groups.includes(e))
    }
  }
}
</script>
